export default __webpack_public_path__ + "static/media/squares300.527a472a.jpg";